<template>
  <Form ref="form" @submit.prevent="submit">
    <ZDialog :show="isVisible">
      <template #header>
        <div>
          <h4 class="modal-title">
            Address
          </h4>
        </div>
      </template>
      <template #body>
        <div>
          <ContactSummary class="mb-4" :contact="value" />
          <div class="form-control custom-form">
            <ZSelect v-model="addressType" :value="addressType" label="Address Type" name="addressType"
              :options="lookups['AddressType']" validate="required" class="mt-3" />
            <ZInput v-model="addressLines" :value="addressLines" name="AddressLines" label="Street Address"
              validate="required" class="mt-3" />
            <ZInput v-model="city" :value="city" name="City" label="City" validate="required" class="mt-3" />
            <ZSelect v-model="stateProvince" :value="stateProvince" label="State" name="stateProvince"
              :options="lookups['StateProvince']" validate="required" class="mt-3" />
            <ZInput v-model="postalCode" :value="postalCode" name="PostalCode" label="Postal Code" validate="required"
              class="mt-3" />
            <ZSelect v-model="country" :value="country" label="Country" name="country" :options="lookups['Country']"
              validate="required" class="mt-3" />
            <ZTextArea v-model="addressNote" :value="addressNote" name="AddressNote" label="Notes" class="mt-3" />
          </div>
        </div>
      </template>
      <template #footer>
        <div>
          <button type="button" class="btn btn-light" @click="close()">Cancel</button>
          <button type="submit" class="btn btn-primary ms-1" @click="save()">Save</button>
        </div>
      </template>
    </ZDialog>
  </Form>
</template>
<script>
import { mapActions, mapState } from 'pinia'
import { lookups, contacts } from '@/stores'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import ZInput from '@/components/utilities/elements/Input.vue'
import ZSelect from '@/components/utilities/elements/Select.vue'
import ZTextArea from '@/components/utilities/elements/TextArea.vue'
import ContactSummary from '@/components/contacts/forms/contact-summary.vue'
import { Form } from 'vee-validate'
export default {
  name: 'contact-address',
  components: {
    ZDialog,
    ZInput,
    ZSelect,
    ZTextArea,
    ContactSummary,
    Form
  },
  props: {
    value: {
      type: Object
    },
    address: {
      type: Object,
      default() {
        return {
          firm: 0,
          contact: 0,
          contactAddress: 0,
          address: 0,
          addressType: 0,
          addressLines: '',
          city: '',
          stateProvince: 0,
          postalCode: '',
          country: 0,
          addressNote: ''
        }
      }
    }
  },
  computed: {
    ...mapState(lookups, ['lookups']),
    addressType: {
      get() {
        return this.address !== null ? this.address.addressType : 0
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'addressType',
          value: parseInt(value)
        })
      }
    },
    addressLines: {
      get() {
        return this.address !== null ? this.address.addressLines : ''
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'addressLines',
          value: value
        })
      }
    },
    city: {
      get() {
        return this.address !== null ? this.address.city : ''
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'city',
          value: value
        })
      }
    },
    stateProvince: {
      get() {
        return this.address !== null ? this.address.stateProvince : 0
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'stateProvince',
          value: parseInt(value)
        })
      }
    },
    postalCode: {
      get() {
        return this.address !== null ? this.address.postalCode : ''
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'postalCode',
          value: value
        })
      }
    },
    country: {
      get() {
        return this.address !== null ? this.address.country : 0
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'country',
          value: parseInt(value)
        })
      }
    },
    addressNote: {
      get() {
        return this.address !== null ? this.address.addressNote : ''
      },
      set(value) {
        this.setItem({
          type: 'Address',
          id: this.address.contactAddress,
          property: 'addressNote',
          value: value
        })
      }
    },
    isVisible: {
      get() {
        return this.value !== null
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    ...mapActions(contacts, ['setItem', 'removeAddress']),
    close() {
      if (this.address.contactAddress === -1) {
        this.removeAddress(-1)
      }
      this.$emit('closing')
    },
    async save() {
      this.$refs.form.validate().then(success => {
        if (success.valid) {
          this.$emit('send', this.address.contactAddress)
        }
      })
    },
    submit() { }
  }
}
</script>
<style lang="scss" scoped>
.custom-form {
  text-align: left;
  max-height: 450px;
  height: 450px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
